module.exports = __webpack_public_path__ + "img/image19.748011b4.webp";